import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SegmentService } from 'ngx-segment-analytics';
import { DataAccessDocumentsTrackingSegmentService } from '@unico-people/shared/form/data-access/data-access-documents-tracking-segment';

import { MixpanelTrackingProvider } from './mixpanel-tracking.service';
import { ITrackingProvider } from './tracking.interface';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Injectable({
  providedIn: 'root'
})
export class TrackingSegmentService {
  public properties = new BehaviorSubject(null);
  public account: string;
  public dialogExportType: string;
  public candidateInfo = new BehaviorSubject(null);
  public trackingProvider: ITrackingProvider;

  constructor(
    private documentTracking: DataAccessDocumentsTrackingSegmentService,
  ) {
    this.trackingProvider = new MixpanelTrackingProvider();
  }

  public track(title: string, properties?: any): void {
    this.trackingProvider.track(title,
      {
        organization: SessionStorage.getItem('organizationName'),
        account: SessionStorage.getItem('currentAccountName'),
        ...properties
      });
  }

  public page(title: string, properties?: any): void {
    this.trackingProvider.trackPageView(title,
      {
        organization: SessionStorage.getItem('organizationName'),
        account: SessionStorage.getItem('currentAccountName'),
        ...properties
      }
    );
  }

  setAccount(properties: any): any {
    const organization =  SessionStorage.getItem('organizationName');
    const account = SessionStorage.getItem('currentAccountName');
    return { account: account, organization: organization,  ...properties }
  }

  public identify(user: string, properties: any): void {
    this.trackingProvider.identifyUser(user, this.setAccount(properties));
  }

  public getProperties(location?) {
    return {
      organization: this.documentTracking.getOrganizationName(),
      account: this.documentTracking.getAccountName(),
      location: location || this.documentTracking.getLocationDocumentAlias()
    };
  }
}
